import React from "react";
import { Loader } from "@progress/kendo-react-indicators";

export default function Spinner() {
  return (
    <div className="loader-overlay">
      <div className="loader-wrapper">
        <svg className="loader-svg" viewBox="0 0 120 120" width="120" height="120">
          {/* explicit x,y, cx, cy, r is needed for mobile otherwise it's not picking it up from css */}
          <image className="loader-logo" href="/images/alpa-logo.png" x="30" y="30" width="60" height="60" />
          
          <g className="loader-arc-spin">
            <circle class="loader-arc-ring" cx="60" cy="60" r="35" />
          </g>
        </svg>
    
        <div className="loader-plane-wrapper">
          <i className="fa-solid fa-plane loader-plane"></i>
        </div>
    </div>
  </div>
  );
}
